import React, { Component } from 'react';
import moment from 'moment';
import SectionFooter from '../../components/views/SectionFooter';
import InputField from '../../components/inputs/inputField';
import TextAreaField from '../../components/inputs/textAreaField';
import CheckboxInput from '../../components/inputs/checkboxInput';
import API from '../../utils/API';

const amenityOptions = [
	'Spa/Salon',
	'Golf',
	'On Site Restaurant(s)',
	'Valet Parking',
	'Self Parking',
	'Business Center',
	'Outdoor Pool',
	'Indoor Pool',
	'Fitness Center'
];

class AdditionalInfo extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			editedVenue: {
				additionalInfo: venue.additionalInfo || {
					responseDueDate: null,
					decisionDate: null,
					requestedAmenities: [],
					eventDescription: '',
					decisionFactors: '',
					budgetDirection: ''
				}
			},
			editing: false,
			saving: false
		};
	}

	updateAdditionalInfo = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.additionalInfo[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	toggleAmenity = (amenity) => {
		const { editedVenue } = this.state;
		const { requestedAmenities } = editedVenue.additionalInfo;
		
		if (requestedAmenities.includes(amenity)) {
			editedVenue.additionalInfo.requestedAmenities = requestedAmenities.filter(a => a !== amenity);
		} else {
			requestedAmenities.push(amenity);
		}
		
		this.setState({ editedVenue, editing: true });
	};

	saveDetails = async () => {
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ additionalInfo: this.state.editedVenue.additionalInfo }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving additional info:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			editedVenue: {
				additionalInfo: venue.additionalInfo || {
					responseDueDate: null,
					decisionDate: null,
					requestedAmenities: [],
					eventDescription: '',
					decisionFactors: '',
					budgetDirection: ''
				}
			},
			editing: false
		});
	};

	render() {
		const { editedVenue, editing } = this.state;
		const { venue } = this.props;
		const { additionalInfo } = editedVenue;
		
		const responseDueDate = additionalInfo.responseDueDate ? moment(additionalInfo.responseDueDate).format('YYYY-MM-DD') : '';
		const decisionDate = additionalInfo.decisionDate ? moment(additionalInfo.decisionDate).format('YYYY-MM-DD') : '';
		
		return (
			<>
				
				<div className="sectionBody">
					<div className="sectionBlock">
						<h2 className="blockHeader">Timeline</h2>
						
						<div className="flex wrap" style={{ gap: '15px' }}>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="Response Due Date"
									type="date"
									value={responseDueDate}
									onChange={(e) => this.updateAdditionalInfo('responseDueDate', e.target.value)}
								/>
							</div>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="Decision Date"
									type="date"
									value={decisionDate}
									onChange={(e) => this.updateAdditionalInfo('decisionDate', e.target.value)}
								/>
							</div>
						</div>
					</div>
					
					<div className="sectionBlock">
						<h2 className="blockHeader">Requested Amenities</h2>
						<p className="grey mb-20">Select all amenities that are important for your event</p>
						
						<div className="flex flex-wrap" style={{ gap: '15px' }}>
							{amenityOptions.map((amenity) => (
								<div key={amenity} style={{ flex: '0 0 calc(33.333% - 10px)', minWidth: '200px' }}>
									<CheckboxInput
										label={amenity}
										checked={additionalInfo.requestedAmenities.includes(amenity)}
										onChange={() => this.toggleAmenity(amenity)}
									/>
								</div>
							))}
						</div>
					</div>
					
					<div className="sectionBlock">
						<h2 className="blockHeader">Event Details & Requirements</h2>
						
						<TextAreaField
							label="Event Description / Requests"
							value={additionalInfo.eventDescription}
							onChange={(e) => this.updateAdditionalInfo('eventDescription', e.target.value)}
							placeholder="Provide a detailed description of your event and any special requests..."
							rows={4}
						/>
						
						<TextAreaField
							label="Decision Factors"
							value={additionalInfo.decisionFactors}
							onChange={(e) => this.updateAdditionalInfo('decisionFactors', e.target.value)}
							placeholder="What factors are most important in your venue selection decision?..."
							rows={4}
						/>
						
						<TextAreaField
							label="Budget Direction and Historical Spend"
							value={additionalInfo.budgetDirection}
							onChange={(e) => this.updateAdditionalInfo('budgetDirection', e.target.value)}
							placeholder="Provide budget guidance and any relevant historical spend information..."
							rows={4}
						/>
					</div>
				</div>
				
				<SectionFooter
					saveEdit={this.saveDetails}
					cancelEdit={this.cancelEdit}
					updatedAt={venue.updatedAt}
					editing={editing}
				/>
			</>
		);
	}
}

export default AdditionalInfo;
